(function () {
    'use strict';

    angular.module("imApp").factory("bspMenuService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 3157,
                    parameters: parms || {}
                });
            },
            listRecordRights: function (parms) {
                return $ihttp.post({
                    method: 88,
                    parameters: parms || {}
                });
            },
            copyObj: function (menu) {
                return $ihttp.post({
                    method: 3609,
                    parameters: menu
                });
            }
        };

        return service;
    }]);
})();
